import React, { Component } from 'react';
import { Form, Input } from 'antd';
import PriceInput from 'components/QRcode/Input/PriceInput';
import PriceSaleInput from 'components/QRcode/Input/PriceSaleInput';
import { calcGST } from 'store/utility';
import { connect } from 'react-redux';

const { Item } = Form;
const { TextArea } = Input;

class QRForm extends Component {
  state = {
    gst: this.props.data.gst || 0,
  };

  componentDidMount() {
    const { settings, data } = this.props;
    if (!settings || !data) {
      return;
    }

    let gst = data.gst ? data.gst : settings.gst || 0;

    this.setState({
      gst: gst,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      const { settings, data } = this.props;
      if (!settings || !data) {
        return;
      }

      let gst = data.gst ? data.gst : settings.gst;

      if (!gst) {
        gst = 0;
      }

      this.setState({
        gst: gst,
      });
    }
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps.settings) {
      const { settings, data } = nextProps;
      if (!data) {
        return;
      }
      this.setState(prev => ({
        ...prev,
        gst: data.gst ? data.gst : settings.gst || 0,
      }));
    }
  };

  checkPrice = (_, value, callback) => {
    if (!value) return callback();
    if (isNaN(parseInt(value.price, 10))) return callback('Please input valid price');
    else if (value.price === 0) return callback('Please input price');
    else return callback();
  };

  checkSalePrice = (_, value, callback) => {
    if (!value) return callback();
    if (isNaN(parseInt(value.price_sale, 10))) return callback('Please input valid sale price');
    return callback();
  };

  render() {
    const { form, data, loggedInRole } = this.props;
    const { getFieldDecorator } = form;
    const price = data.price_cents / 100;
    const price_sale = data.price_sale / 100;
    const inputEditable = loggedInRole !== 'SALES';
    // const gst = this.state.gst ? this.state.gst : this.props.settings ? this.props.settings.gst : 0;
    const gst = this.props.settings ? this.props.settings.gst : 0;

    return (
      <Form layout="horizontal">
        <Item label="Price" style={{ marginLeft: 0, marginBottom: 5 }}>
          {getFieldDecorator('price', {
            rules: [{ required: true }, { validator: this.checkPrice }],
            initialValue: {
              price: price,
              gst: gst,
              price_gst: calcGST(price, gst, 'cents'),
            },
          })(<PriceInput disabled={!inputEditable} />)}
        </Item>

        <Item label="Sales price" style={{ marginLeft: 0, marginBottom: 5 }}>
          {getFieldDecorator('price_sale', {
            rules: [{ required: false }, { validator: this.checkSalePrice }],
            initialValue: {
              price_sale: price_sale,
              gst: gst,
              price_sale_gst: calcGST(price_sale, gst, 'cents'),
            },
          })(<PriceSaleInput disabled={!inputEditable} />)}
        </Item>

        <Item label="Unit">
          {getFieldDecorator('unit', {
            rules: [{ required: true }],
            initialValue: data.price_unit,
          })(<Input disabled={!inputEditable} style={{ width: '100px' }} />)}
        </Item>
        <Item label="Remark(s)">
          {getFieldDecorator('remark', {
            initialValue: data.remark,
          })(<TextArea rows={4} type="remark" placeholder="Remark(s)" />)}
        </Item>
      </Form>
    );
  }
}

const mapStateToProps = state => {
  return {
    loggedInRole: state.auth.role,
    settings: state.setting.settings,
  };
};

export default connect(mapStateToProps)(QRForm);



// WEBPACK FOOTER //
// ./src/components/QRcode/Form/EditQRForm.js